import { CatalogLayoutEditStatus } from './catalog.layout.edit.status';

export class CatalogLayoutBaseObject {
  Status: CatalogLayoutEditStatus;
}
